import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineDocumentText } from "react-icons/hi";

const AiDocTemplateExample: React.FC = () => {
  const { t } = useTranslation();

  const fields = [
    {
      name: "amount_excl_tax",
      desc: t("dashboard.docTemplates.example.field1Desc"),
    },
    {
      name: "invoice_date",
      desc: t("dashboard.docTemplates.example.field2Desc"),
    },
    {
      name: "invoice_number",
      desc: t("dashboard.docTemplates.example.field3Desc"),
    },
  ];

  return (
    <div className="relative rounded-lg border border-dashed border-gray-300 bg-gray-50/70 p-3 sm:p-4 select-none">
      <span className="absolute -top-2.5 left-3 inline-flex items-center gap-1 rounded-full bg-gray-100 border border-gray-300 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-gray-500">
        <HiOutlineDocumentText size={11} />
        {t("dashboard.docTemplates.example.badge")}
      </span>

      <div className="mb-3 mt-1">
        <div className="text-xs font-medium text-gray-400 mb-1">
          {t("dashboard.docTemplates.nameLabel")}
        </div>
        <div className="w-full max-w-56 text-xs rounded border border-gray-200 bg-white/60 px-2 py-1.5 text-gray-500">
          {t("dashboard.docTemplates.example.docName")}
        </div>
      </div>

      {/* Fields */}
      <div className="rounded-md bg-white/50 border border-gray-100 p-2 sm:p-3 flex flex-col gap-2">
        {fields.map((f, i) => (
          <div key={i} className="flex flex-col sm:flex-row gap-2">
            <div className="w-full sm:w-56 sm:flex-none text-xs rounded border border-gray-200 bg-white/60 px-2 py-1.5 font-mono text-gray-500">
              {f.name}
            </div>
            <div className="flex-1 min-w-0 text-xs rounded border border-gray-200 bg-white/60 px-2 py-1.5 text-gray-500">
              {f.desc}
            </div>
          </div>
        ))}
      </div>

      {/* One-line hint under the example */}
      <p className="mt-3 text-xs text-gray-400">
        {t("dashboard.docTemplates.example.hint")}
      </p>
    </div>
  );
};

export default AiDocTemplateExample;
